import "chart.js/auto";
import {
  Button,
  CustomImage,
  DatePicker,
  DateRange,
  IconDocument,
  OptionInterface,
  Select,
  SelectOption,
  Table,
  TableColumnWidth,
  TableColumns,
  TableData,
  TablePagination,
  TablePreferences,
  Tabs,
  TextBox,
  Toggle,
} from "@veneer/core";
import { useEffect, useMemo, useState } from "react";
import UsersManagementService from "../../services/userManagementApi/usersManagement.service";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { IGetAttendanceByRouteDto } from "../../models/dto/userManagementApi/IGetAttendanceByRoleDto";
import { useTranslation } from "react-i18next";
import IconUserNotFound from "../../assets/img/attendance/VectoruserNotFound.png";
import "../../assets/css/views/attendance/attendance.css";

import { Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import dataListService from "../../services/generalApi/dataList.service";
import { IGetSupervisorListDto } from "../../models/dto/userManagementApi/IGetSupervisorListDto";
import { decryptText } from "../../utils/encryptionUtils";
import { ISupervisorDto } from "../../models/dto/generalApi/ISupervisorDto";
import { ICoordinatorDto } from "../../models/dto/generalApi/ICoordinatorDto";
import moment from "moment";
import SimpleMessageModalWithOpenClose from "../../components/Modals/SimpleMessageModalWithOpenClose";
import LoaderModal from "../../components/Loader/loaderModal";
import { ModalInformational } from "../SellOut/SellOutComponent/ModalInformational";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

interface IValuesSelector {
  value: number;
  label?: string;
}

interface IPercentages {
  routeCompletedSuccessfully: number;
  routeProgress: number;
  routeCompletedUnsuccessfully: number;
}

interface IGetAttendanceResponseByRoleDto {
  records: IGetAttendanceByRouteDto[];
  percentages: IPercentages;
  quantityTotalAttendance: number;
}

export default function AttendanceRoute() {
  type SelectValue = number | string | boolean;

  const [t] = useTranslation("global");
  const languageID: any = useSelector((state: RootState) => state.languageId);
  const [tableData, setTableData] = useState<TableData[]>([]);
  const [tableSummaryData, setTableSummaryData] = useState<TableData[]>([]);
  const [tableSummaryDataFiltered, setTableSummaryDataFiltered] = useState<
    TableData[]
  >([]);
  const [tableDataFiltered, setTableDataFiltered] = useState<TableData[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [selectedTabIdDefault, setSelectedTabIdDefault] = useState(1);
  const [loading, setLoading] = useState(false);
  const [selectDate, setSelectDate] = useState<string>("");
  const [searchUser, setSearchUser] = useState<string>("");
  const [searchUserSummary, setSearchUserSummary] = useState<string>("");
  const [searchPointOfSale, setSearchPointOfSale] = useState<string>("");
  const [valueRole, setValueRole] = useState<number[]>([]);
  const [optionsRole, setOptionsRole] = useState<IValuesSelector[]>([]);
  const [visibleTableSummaryData, setVisibleTableSummaryData] =
    useState<boolean>(true);
  const userState: any = useSelector((state: RootState) => state.user);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [periodTypeSelected, setPeriodTypeSelected] = useState<SelectValue[]>([
    1,
  ]);

  const [supervisors, setSupervisors] = useState<SelectOption[]>([]);
  const [supervisorSelected, setSupervisorSelected] = useState<SelectValue[]>(
    []
  );
  const [disabledSupervisors, setDisabledSupervisors] = useState<boolean>(true);
  const [textDateSelected, setTextDateSelected] = useState<string>("");

  const [percentages, setPercentages] = useState<IPercentages>({
    routeCompletedSuccessfully: 0,
    routeCompletedUnsuccessfully: 0,
    routeProgress: 0,
  });

  interface IModalError {
    show: boolean;
    message: string;
  }

  const [modalError, setModalError] = useState<IModalError>({
    show: false,
    message: "",
  });

  const [messageModal, setMessageModal] = useState({
    title: "",
    message: "",
  });
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    let currentDate = new Date().toString();
    setSelectDate(formattedDate(currentDate));
    setPeriodTypeSelected([1]);
    calculateRangeSelected(1, currentDate);
    getAttendanceByRoute(
      formattedDate(currentDate),
      Number(periodTypeSelected),
      languageID.value,
      1,
      null,
      visibleTableSummaryData
    );
    getSupervisorData();

    if (!visibleTableSummaryData || Number(periodTypeSelected) === 1) {
      setSelectedTabIdDefault(1);
      return;
    }
  }, [languageID]);

  const getSupervisorData = async () => {
    const role = Number(decryptText(userState.user.roleId));
    const userId = Number(decryptText(userState.user.userId));

    try {
      let data: SelectOption[] = [];

      if (role === 30) {
        const [supervisors, coordinators] = await Promise.all([
          dataListService.getSupervisorBySubRegion(),
          dataListService.getCoordinatorBySubRegion(),
        ]);

        const mappedSupervisors = supervisors.map(
          (s: IGetSupervisorListDto) => ({
            value: s.userID,
            label: s.fullName,
          })
        );

        const mappedCoordinators = coordinators.map((c: ICoordinatorDto) => ({
          value: c.coordinatorId,
          label: c.fullName,
        }));

        data = [...mappedSupervisors, ...mappedCoordinators];
      }

      if (role === 29) {
        const supervisors = await dataListService.getSupervisorByCoordinator(
          userId
        );
        data = supervisors.map((s: ISupervisorDto) => ({
          value: s.supervisorID,
          label: s.fullName,
        }));
      }

      if (role !== 2 && data.length > 0) {
        setSupervisors(data);
        setDisabledSupervisors(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setDisabledSupervisors(true);
    }
  };

  let formattedDate = (date: string) => {
    let currentDate = new Date(date);
    let year = currentDate.getFullYear();
    let month = currentDate.getMonth() + 1;
    let day = currentDate.getDate();
    let formattedDate = year + "-" + month + "-" + day;

    return formattedDate;
  };

  let formattedDateFormat2 = (date: string) => {
    let currentDate = new Date(date);
    let year = currentDate.getFullYear();
    let month = currentDate.getMonth() + 1;
    let day = currentDate.getDate();
    let formattedDate = month + "/" + day + "/" + year;

    return formattedDate;
  };

  const handleChangeSearchUser = (value: string) => {
    cleanAll();
    setSearchUser(value);
    const filterArray = tableDataFiltered.filter((element) =>
      element.user.toString().toLowerCase().includes(value.toLowerCase())
    );
    setTableData(filterArray);
  };

  const handleChangeSearchUserSummary = (value: string) => {
    cleanAll();
    setSearchUserSummary(value);
    const filterArray = tableSummaryDataFiltered.filter((element) =>
      element.user.toString().toLowerCase().includes(value.toLowerCase())
    );
    setTableSummaryData(filterArray);
  };

  const handleChangeSearchPointOfSale = (value: string) => {
    cleanAll();
    setSearchPointOfSale(value);
    const filterArray = tableDataFiltered.filter((element) =>
      element.poscodes.toString().toLowerCase().includes(value.toLowerCase())
    );
    setTableData(filterArray);
  };

  const onChangeRole = (e: any) => {
    cleanAll();
    setValueRole([e.value]);

    const filterArray = tableDataFiltered.filter((element) =>
      element.role.toString().toLowerCase().includes(e.label.toLowerCase())
    );
    setTableData(filterArray);
  };

  const columnsWidth: TableColumnWidth[] = [
    { columnId: "user", maxWidth: "20%" },
    { columnId: "poscodes", maxWidth: "20%" },
    { columnId: "role", maxWidth: "10%" },
    { columnId: "date", maxWidth: "10%" },
    { columnId: "programedTimeIn", maxWidth: "5%" },
    { columnId: "programedTimeOut", maxWidth: "5%" },
    { columnId: "recordedTime", maxWidth: "5%" },
    { columnId: "recordedTimeOut", maxWidth: "5%" },
    { columnId: "photo", maxWidth: "5%" },
    { columnId: "photoOut", maxWidth: "5%" },
    { columnId: "visitedStores", maxWidth: "5%" },
    { columnId: "scheduledStores", maxWidth: "5%" },
  ];

  const tablePreferences: TablePreferences = {
    width: columnsWidth,
  };

  const columns = useMemo<TableColumns[]>(() => {
    return [
      {
        id: "user",
        label: t("header.user"),
        filter: (
          <TextBox
            id="attendanceTextboxUser"
            label={t("header.search")}
            type="search"
            onChange={handleChangeSearchUser}
            value={searchUser}
          />
        ),
      },
      {
        id: "poscodes",
        label: t("header.posOfCodes"),
        filter: (
          <TextBox
            id="attendanceTextboxPointOfSale"
            label={t("header.search")}
            type="search"
            onChange={handleChangeSearchPointOfSale}
            value={searchPointOfSale}
          />
        ),
      },
      {
        id: "role",
        label: t("header.role"),
        filter: (
          <Select
            options={optionsRole}
            id="selectRole"
            placement="bottom"
            helperTextVisibility="auto"
            onChange={onChangeRole}
            value={valueRole}
            onClear={() => onClearSelect()}
          />
        ),
      },
      { id: "date", label: t("header.date") },
      { id: "programedTimeIn", label: t("header.programedTime") },
      { id: "recordedTimeIn", label: t("header.recordedTime") },
      ...(periodTypeSelected[0] === 1
        ? [{ id: "photo1", label: t("header.photoIn") }]
        : []),
      { id: "programedTimeOut", label: t("header.programedTimeOut") },
      { id: "recordedTimeOut", label: t("header.recordedTimeOut") },
      ...(periodTypeSelected[0] === 1
        ? [{ id: "photo2", label: t("header.photoOut") }]
        : []),
      ...(periodTypeSelected[0] === 1
        ? [{ id: "visitedStores", label: t("header.visitedStores") }]
        : []),
      ...(periodTypeSelected[0] === 1
        ? [{ id: "scheduledStores", label: t("header.scheduledStores") }]
        : []),
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    periodTypeSelected,
    searchUser,
    searchPointOfSale,
    optionsRole,
    valueRole,
    t,
  ]);

  const columnsSummaryTable: TableColumns[] = [
    {
      id: "user",
      label: t("header.user"),
      filter: (
        <TextBox
          id="attendanceTextboxUser"
          label={t("header.search")}
          type="search"
          onChange={handleChangeSearchUserSummary}
          value={searchUserSummary}
        />
      ),
    },
    {
      id: "routeCompletedSuccessfully",
      label: t("header.routeCompletedSuccessfully"),
    },
    {
      id: "routeProgress",
      label: t("header.routeProgress"),
    },
    {
      id: "routeCompletedUnsuccessfully",
      label: t("header.routeCompletedUnsuccessfully"),
    },
    {
      id: "visitedStores",
      label: t("header.visitedStores"),
    },
    {
      id: "scheduledStores",
      label: t("header.scheduledStores"),
    },
  ];

  const columnsSummaryWidth: TableColumnWidth[] = [
    { columnId: "user", width: "50%" },
    { columnId: "routeProgress", width: "10%" },
    { columnId: "routeCompletedSuccessfully", width: "10%" },
    { columnId: "routeCompletedUnsuccessfully", width: "10%" },
    { columnId: "visitedStores", width: "10%" },
    { columnId: "scheduledStores", width: "10%" },
  ];

  const tableSummaryPreferences: TablePreferences = {
    width: columnsSummaryWidth,
  };

  const pagedData = tableData.slice(
    (currentPage - 1) * pageSize,
    (currentPage - 1) * pageSize + pageSize
  );

  const pagedDataSummary = tableSummaryData.slice(
    (currentPage - 1) * pageSize,
    (currentPage - 1) * pageSize + pageSize
  );

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (
    event: React.MouseEvent<HTMLElement>,
    option: OptionInterface<number>
  ) => {
    setPageSize(option.value);
  };

  const paginationProps: TablePagination = {
    currentPage,
    onPageChange: handlePageChange,
    onPageSizeChange: handlePageSizeChange,
    pageSize,
    totalItems: tableData.length,
  };

  const paginationSummaryProps: TablePagination = {
    currentPage,
    onPageChange: handlePageChange,
    onPageSizeChange: handlePageSizeChange,
    pageSize,
    totalItems: tableSummaryData.length,
  };

  //Tabs
  const onChangeTab = (value: number) => {
    cleanAll();
    let supervisorId =
      supervisorSelected.length > 0 ? Number(supervisorSelected) : null;
    getAttendanceByRoute(
      formattedDate(selectDate),
      Number(periodTypeSelected),
      languageID.value,
      value,
      supervisorId,
      visibleTableSummaryData
    );
    setSelectedTabIdDefault(value);
  };

  const getAttendanceByRoute = async (
    date: string,
    periodType: number,
    languageId: number,
    status: number,
    supervisorId: number | null,
    visibleTableSummary: boolean
  ) => {
    setLoading(true);

    if (!visibleTableSummary || periodType === 1) {

      setMessageModal({
        title: "",
        message: t("header.getDailyInfo"),
      });
      if (periodType === 2) {
        setMessageModal({
          title: "",
          message: t("header.getDetailedWeeklyInfo"),
        });
      }
      if (periodType === 3) {
        setMessageModal({
          title: "",
          message: t("header.getDetailedMonthlyInfo"),
        });
      }
      await UsersManagementService.getAttendanceByRoute(
        date,
        periodType,
        languageId,
        status,
        supervisorId
      ).then((result: IGetAttendanceResponseByRoleDto) => {
        
        calculateQuantitiesByPercentages(
          result.percentages,
          result.quantityTotalAttendance
        );

        fillData(result.records, periodType);
        setPercentages(result.percentages);
      });
      return;
    }

    if (periodType === 2) {
      setMessageModal({
        title: "",
        message: t("header.getSummarizedWeeklyInfo"),
      });
    }
    if (periodType === 3) {
      setMessageModal({
        title: "",
        message: t("header.getSummarizedMonthlyInfo"),
      });
    }
    await UsersManagementService.getAttendanceByRoute(
      formattedDate(String(date)),
      Number(periodType),
      languageId,
      0,
      supervisorId
    ).then((result: IGetAttendanceResponseByRoleDto) => {
      calculateQuantitiesByPercentages(
        result.percentages,
        result.quantityTotalAttendance
      );
      fillDataSummary(result.records);
      setPercentages(result.percentages);
    });
  };

  const calculateQuantitiesByPercentages = (
    percentages: IPercentages,
    quantityTotalAttendance: number
  ) => {
    percentages.routeCompletedSuccessfully = Math.round(
      (percentages.routeCompletedSuccessfully / 100) * quantityTotalAttendance
    );
    percentages.routeCompletedUnsuccessfully = Math.round(
      (percentages.routeCompletedUnsuccessfully / 100) * quantityTotalAttendance
    );
    percentages.routeProgress = Math.round(
      (percentages.routeProgress / 100) * quantityTotalAttendance
    );
  };

  const fillData = async (
    data: IGetAttendanceByRouteDto[],
    periodType: number
  ) => {
    const pagedData: TableData[] = [];

    for (let i = 0; i < data.length; i++) {
      const attendance: IGetAttendanceByRouteDto = data[i];
      let tableData: TableData = {};

      tableData = {
        user: attendance.fullName,
        poscodes: attendance.posCodes,
        role: attendance.role,
        date: formattedDateFormat2(attendance.date.toString()),
        programedTimeIn: attendance.programedTimeIn,
        recordedTimeIn:
          attendance.recordedTimeIn !== null &&
          attendance.recordedTimeIn !== undefined
            ? attendance.recordedTimeIn
            : "",
        photo1:
          periodType === 1 && attendance.photo !== null ? (
            <CustomImage size={55} quietArea={0} src={attendance.photo} />
          ) : (
            <div className="DivIconCustomNoItemsAttendance">
              <CustomImage size={55} quietArea={10} src={IconUserNotFound} />
            </div>
          ),
        programedTimeOut: attendance.programedTimeOut,
        recordedTimeOut:
          attendance.recordedTimeOut !== null &&
          attendance.recordedTimeOut !== undefined
            ? attendance.recordedTimeOut
            : "",
        photo2:
          periodType === 1 && attendance.photoOut !== null ? (
            <CustomImage size={55} quietArea={0} src={attendance.photoOut} />
          ) : (
            <div className="DivIconCustomNoItemsAttendance">
              <CustomImage size={55} quietArea={10} src={IconUserNotFound} />
            </div>
          ),
        visitedStores: attendance.visitedStores,
        scheduledStores: attendance.scheduledStores,
        rowConfig: {
          disabled: false,
          noWrap: false,
          selected: false,
        },
      };

      pagedData.push(tableData);
    }
    setTableData(pagedData);
    setTableDataFiltered(pagedData);

    const roles = pagedData.reduce((accumulator, user) => {
      if (!accumulator.includes(user.role)) {
        accumulator.push(user.role);
      }
      return accumulator;
    }, []);

    const updatedOptionsRole = roles.map((role: string, index: number) => ({
      value: index + 1,
      label: role,
    }));
    setOptionsRole(updatedOptionsRole);

    setLoading(false);
  };

  const fillDataSummary = (data: IGetAttendanceByRouteDto[]) => {
    let dataFormat: any[] = [];

    for (let i = 0; i < data.length; i++) {
      const attendance: IGetAttendanceByRouteDto = data[i];

      let tableData: any = {
        userID: attendance.userID,
        user: attendance.fullName,
        status: attendance.status,
        visitedStores: attendance.visitedStores,
        scheduledStores: attendance.scheduledStores,
        rowConfig: {
          disabled: false,
          noWrap: false,
          selected: false,
        },
      };
      dataFormat.push(tableData);
    }

    const pagedData: TableData[] = dataFormat.reduce(
      (arrayResult, attendance) => {
        const found = arrayResult.find(
          (i: any) => i.userID === attendance.userID
        );

        if (!found) {
          arrayResult.push({
            ...attendance,
            routeCompletedSuccessfully: attendance.status === 1 ? 1 : 0,
            routeProgress: attendance.status === 2 ? 1 : 0,
            routeCompletedUnsuccessfully: attendance.status === 3 ? 1 : 0,
          });
        } else {
          switch (attendance.status) {
            case 1:
              found.routeCompletedSuccessfully++;
              break;
            case 2:
              found.routeProgress++;
              break;
            case 3:
              found.routeCompletedUnsuccessfully++;
              break;
            default:
              break;
          }
        }

        return arrayResult;
      },
      []
    );
    
    setTableSummaryData(pagedData);
    setTableSummaryDataFiltered(pagedData);
    setLoading(false);
  };

  const handleChangeStartDate = (date: DateRange) => {
    cleanAll();
    setSelectDate(String(date));
    calculateRangeSelected(Number(periodTypeSelected), String(date));
    let supervisorId =
      supervisorSelected.length > 0 ? Number(supervisorSelected) : null;
    getAttendanceByRoute(
      formattedDate(String(date)),
      Number(periodTypeSelected),
      languageID.value,
      selectedTabIdDefault,
      supervisorId,
      visibleTableSummaryData
    );
  };

  const handleChangePeriodType = (value: number) => {
    cleanAll();
    setPeriodTypeSelected([value]);
    calculateRangeSelected(value, selectDate);
    let supervisorId =
      supervisorSelected.length > 0 ? Number(supervisorSelected) : null;

    getAttendanceByRoute(
      formattedDate(String(selectDate)),
      Number(value),
      languageID.value,
      selectedTabIdDefault,
      supervisorId,
      visibleTableSummaryData
    );
  };

  const calculateRangeSelected = (
    periodTypeSelected: number,
    dateSelected: string
  ) => {
    const initialText: string = t("header.daysSelected");
    var startDate = "",
      endDate = "";

    if (periodTypeSelected === 1) {
      startDate = moment(dateSelected).format("MM/DD/YYYY").toString();
      endDate = moment(dateSelected).format("MM/DD/YYYY").toString();
    }

    if (periodTypeSelected === 2) {
      const today = moment();

      // Start of the week (Monday)
      startDate = moment(dateSelected)
        .startOf("week")
        .format("MM/DD/YYYY")
        .toString(); // Monday // Start of current week (Monday)

      const currentWeekStart = moment(today).startOf("week");

      if (
        moment(dateSelected).isSameOrAfter(currentWeekStart) &&
        moment(dateSelected).isSameOrBefore(today)
      ) {
        // If the date is in the current week, use today as the end date
        endDate = moment(today).format("MM/DD/YYYY").toString();
      } else {
        // Otherwise, use Sunday of that week
        endDate = moment(startDate)
          .add(6, "days")
          .format("MM/DD/YYYY")
          .toString();
      }
    }

    if (periodTypeSelected === 3) {
      const today = moment(); // Start of the month

      startDate = moment(dateSelected)
        .startOf("month")
        .format("MM/DD/YYYY")
        .toString();

      if (
        moment(dateSelected).month() === today.month() &&
        moment(dateSelected).year() === today.year()
      ) {
        // If it's the current month, use today
        endDate = moment(today).format("MM/DD/YYYY").toString();
      } else {
        // Otherwise, use end of the month
        endDate = moment(dateSelected)
          .endOf("month")
          .format("MM/DD/YYYY")
          .toString();
      }
    }

    setTextDateSelected(
      initialText.replace("{0}", startDate).replace("{1}", endDate)
    );
  };

  const handleChangeSupervisor = (value: number) => {
    cleanAll();
    setSupervisorSelected([value]);
    let supervisorId = !isNaN(value) ? Number(value) : null;
    getAttendanceByRoute(
      formattedDate(String(selectDate)),
      Number(periodTypeSelected),
      languageID.value,
      selectedTabIdDefault,
      supervisorId,
      visibleTableSummaryData
    );
  };

  const handleOnClearSupervisor = () => {
    cleanAll();
    setSupervisorSelected([]);
    getAttendanceByRoute(
      formattedDate(String(selectDate)),
      Number(periodTypeSelected),
      languageID.value,
      selectedTabIdDefault,
      null,
      visibleTableSummaryData
    );
  };

  const handleChangeVisibleSummaryTable = (visible: boolean) => {
    cleanAll();
    setVisibleTableSummaryData(visible);
    let supervisorId =
      supervisorSelected.length > 0 ? Number(supervisorSelected) : null;
    getAttendanceByRoute(
      formattedDate(String(selectDate)),
      Number(periodTypeSelected),
      languageID.value,
      selectedTabIdDefault,
      supervisorId,
      visible
    );
  };

  const getAttendanceExcel = () => {
    setLoadingDownload(true);
    UsersManagementService.getAttendanceRouteExcel(
      formattedDate(selectDate),
      Number(periodTypeSelected),
      languageID.value,
      supervisorSelected.length > 0 ? Number(supervisorSelected) : null
    ).then((r: Blob | any) => {
      try {
        if (r?.statusCode === 401) {
          setModalError({
            show: true,
            message: t("modal.generalError"),
          });
          console.error("Error:", "Download failed");
        } else if (r instanceof Blob) {
          try {
            const fileName = "assist_control";
            const url = window.URL.createObjectURL(r);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName + ".xlsx");
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
          } catch (error) {
            console.error("Error al descargar el archivo:", error);
          }
        }
      } catch (error) {
        console.error("Error:", "Download failed: ", error);
        setModalError({
          show: true,
          message: t("modal.generalError"),
        });
      } finally {
        setLoadingDownload(false);
      }
    });
  };

  const cleanAll = () => {
    setCurrentPage(1);
    setTableData([]);
    setTableSummaryData([]);
    setSearchPointOfSale("");
    setSearchUser("");
    setSearchUserSummary("");
    setValueRole([]);
  };

  const onClearSelect = () => {
    setValueRole([]);
    setTableData(tableDataFiltered);
  };

  const chartData = {
    labels: [
      t("header.routeProgress"),
      t("header.routeCompletedUnsuccessfully"),
      t("header.routeCompletedSuccessfully"),
    ],
    datasets: [
      {
        data: [
          percentages.routeProgress,
          percentages.routeCompletedUnsuccessfully,
          percentages.routeCompletedSuccessfully,
        ],
        backgroundColor: [
          "#FFCDD2", // routeProgress
          "#FFF59D", // routeCompletedUnsuccessfully
          "#A9DFBF", // On Time
        ],
        hoverOffset: 5,
      },
    ],
  };

  const chartOptions = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        position: "right" as "right",
      },
      tooltip: {
        callbacks: {
          label: function (context: any) {
            let value = context.raw || 0;
            let total = context.dataset.data.reduce(
              (acc: any, curr: any) => acc + curr,
              0
            );
            let percentage = ((value / total) * 100).toFixed(2) + "%";
            return ` ${value} (${percentage})`;
          },
        },
      },
    },
  };

  const optionsTypePeriod: SelectOption[] = [
    { value: 1, label: t("header.daily") },
    { value: 2, label: t("header.weekly") },
    { value: 3, label: t("header.monthly") },
  ];

  return (
    <>
      {loadingDownload && (
        <div>
          <LoaderModal />
        </div>
      )}

      <div style={{ padding: "20px" }}>
        <h4>{t("header.attendanceRoute")}</h4>
      </div>

      <div
        style={{
          padding: "0.8%",
          display: "flex",
          flexWrap: "wrap",
          gap: "1rem",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            flex: "1 1 400px",
            display: "flex",
            gap: "1rem",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "0.5rem",
              flex: "1 1 250px",
            }}
          >
            <Select
              label={t("header.selectPeriod")}
              options={optionsTypePeriod}
              value={periodTypeSelected}
              onChange={(e) => handleChangePeriodType(Number(e.value))}
              placement="bottom-start"
              clearIcon={false}
            />
            <Select
              label={t("header.selectUser")}
              options={supervisors}
              value={supervisorSelected}
              onChange={(e) => handleChangeSupervisor(Number(e.value))}
              onClear={() => handleOnClearSupervisor()}
              disabled={disabledSupervisors}
              placement="bottom-start"
            />
          </div>

          <DatePicker
            monthYearNavigation
            onChange={(date) => handleChangeStartDate(date as DateRange)}
            clearIcon={false}
            value={selectDate}
            placeholder="dd/mm/yyyy"
            format="L"
            blockFutureDates
            enableOutsideDays
          />
        </div>

        <div
          style={{
            minWidth: "500px",
            maxWidth: "100%",
            height: "150px",
          }}
        >
          <Pie data={chartData} options={chartOptions} />
        </div>

        <div className="buttons-right-attendance">
          <div className="tooltip tooltip-attendance">
            <span className="tooltiptext">{t("header.downloadAttendance")}</span>
            <Button
              onClick={() => getAttendanceExcel()}
              style={{ margin: "5px" }}
              appearance="secondary"
              leadingIcon={<IconDocument />}
            ></Button>
          </div>
        </div>
      </div>

      {Number(periodTypeSelected) !== 1 && (
        <div style={{ float: "left" }}>
          <h5>{textDateSelected}</h5>
        </div>
      )}

      {periodTypeSelected && Number(periodTypeSelected) !== 1 && (
        <div style={{ float: "right" }}>
          <Toggle
            id="toggle1"
            label={t("header.summaryData")}
            on={visibleTableSummaryData}
            onChange={() =>
              handleChangeVisibleSummaryTable(!visibleTableSummaryData)
            }
          />
        </div>
      )}

      {(!visibleTableSummaryData || Number(periodTypeSelected) === 1) && (
        <div style={{ width: "100%", float: "left" }}>
          <Tabs
            controlId="default"
            onChangeTab={(value) => onChangeTab(value)}
            selectedTabId={selectedTabIdDefault}
            tabs={[
              {
                id: 1,
                label: t("header.routeCompletedSuccessfully"),
                content: (
                  <div
                    style={{
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "center",
                      padding: "30px",
                    }}
                  >
                    <Table
                      key={`period-${periodTypeSelected[0]}`}
                      className="attendance-table"
                      showFilters={true}
                      behavior={{
                        type: "singlePage",
                      }}
                      columnResize
                      loading={loading}
                      columns={columns}
                      data={pagedData}
                      loadingDataLength={10}
                      preferences={tablePreferences}
                      pagination={paginationProps}
                      rerenderColumnsOnLoad={true}
                    />
                  </div>
                ),
              },
              {
                id: 2,
                label: t("header.routeProgress"),
                content: (
                  <div
                    className="label"
                    style={{
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "center",
                      padding: "30px",
                    }}
                  >
                    <Table
                      key={`period-${periodTypeSelected[0]}`}
                      className="attendance-table"
                      showFilters={true}
                      behavior={{
                        type: "singlePage",
                      }}
                      columnResize
                      loading={loading}
                      columns={columns}
                      data={pagedData}
                      loadingDataLength={10}
                      preferences={tablePreferences}
                      pagination={paginationProps}
                    />
                  </div>
                ),
              },
              {
                id: 3,
                label: t("header.routeCompletedUnsuccessfully"),
                content: (
                  <div
                    className="label"
                    style={{
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "center",
                      padding: "30px",
                    }}
                  >
                    <Table
                      key={`period-${periodTypeSelected[0]}`}
                      className="attendance-table"
                      showFilters={true}
                      behavior={{
                        type: "singlePage",
                      }}
                      columnResize
                      loading={loading}
                      columns={columns}
                      data={pagedData}
                      loadingDataLength={10}
                      preferences={tablePreferences}
                      pagination={paginationProps}
                    />
                  </div>
                ),
              },
            ]}
            type="attached"
          />
        </div>
      )}

      {visibleTableSummaryData && Number(periodTypeSelected) !== 1 && (
        <Table
          className="attendance-table"
          showFilters={true}
          behavior={{
            type: "singlePage",
          }}
          columnResize
          loading={loading}
          columns={columnsSummaryTable}
          data={pagedDataSummary}
          loadingDataLength={10}
          preferences={tableSummaryPreferences}
          pagination={paginationSummaryProps}
          rerenderColumnsOnLoad={true}
        />
      )}

      <SimpleMessageModalWithOpenClose
        showModal={modalError.show}
        setOpenCloseModal={() =>
          setModalError((prevState) => ({ ...prevState, show: false }))
        }
        modalTitle={t("header.error")}
        modalMessage={modalError.message}
      />

      <ModalInformational
        idKey="modal-DeleteOk"
        setOpenCloseModal={() => setOpenModal(false)}
        openModal={openModal}
        titleMessage={messageModal.title}
        message={messageModal.message}
        onClickOk={() => setOpenModal(false)}
      />

      {loading && (
        <div>
          <LoaderModal>
            <div> {messageModal.message}</div>
          </LoaderModal>
        </div>
      )}
    </>
  );
}
